module.exports = __webpack_public_path__ + "components/rewards/bird-eyewear/static/logo-8f5834455dd8809bca26d291b5c1b633.jpg";